import React from "react"
import './NotFoundData.scss';

export default class NotFoundData extends React.PureComponent<{
    title?: string,
    subTitle?: string,
    image?: string,
    config?: {
        width: string,
        height: string,
        titleClass: string
        subTitleClass: string
    }
}, {}> {
    constructor(props: any) {
        super(props);
        this.state = {};

    }

    render(): React.ReactNode {
        let { title, image, config, subTitle } = this.props;

        let subTitleContent;
        if (subTitle !== null && subTitle !== undefined) {
            subTitleContent = <label className={config?.subTitleClass}>
                <label>{subTitle}</label>
            </label>;
        }
        else
            subTitleContent = <></>;

        return <>
            <div className="row">
                <div className="col-12" >
                    <img src={image} width={config?.width} height={config?.height} alt="not found data" />
                </div>
                <div className="col-12">
                    <label className={config?.titleClass}>
                        <label>{title}</label>
                    </label>
                    {subTitleContent}
                </div>
            </div>
        </>;
    }
}